import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'

async function fetchCard (cityId, token, cardId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'loyalty-cards', cardId.toString())
    const response = await axios.get(url, {headers: { Authorization: `Bearer ${token}` }})

    return response.data
}

async function fetchCardLatestCredits (cityId, token, cardId, limit = null)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'loyalty-cards', cardId.toString(), 'latest-credits')
    const response = await axios.get(url, { params: {limit}, headers: { Authorization: `Bearer ${token}` }})

    return response.data
}

async function fetchCardLatestRewards (cityId, token, cardId, limit = null)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'loyalty-cards', cardId.toString(), 'latest-rewards')
    const response = await axios.get(url, { params: {limit}, headers: { Authorization: `Bearer ${token}` }})

    return response.data
}

async function fetchUserCard (cityId, token, userId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'loyalty-cards', 'users', userId.toString())
    const response = await axios.get(url, {headers: { Authorization: `Bearer ${token}` }})

    return response.data
}

async function creditCard (cityId, token, cardId, storeId, points)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'loyalty-cards', cardId.toString(), 'credit')
    const response = await axios.post(url, {storeId, points}, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function redeemReward (cityId, token, cardId, rewardId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'loyalty-cards', cardId.toString(), 'redeem-reward', rewardId.toString())
    const response = await axios.post(url, null, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function generateCardScanCode (cityId, token, cardId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'loyalty-cards', cardId.toString(), 'generate-scan-code')
    const response = await axios.post(url, null, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function getCardFromScanCode (cityId, token, scancode)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'loyalty-cards', 'from-scancode', scancode.toString())
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

export default { fetchCard, fetchCardLatestCredits, fetchCardLatestRewards, fetchUserCard, creditCard, redeemReward, generateCardScanCode, getCardFromScanCode }


// WEBPACK FOOTER //
// ./src/services/loyaltyCards.js